/*
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2024-02-02 11:25:49
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2025-07-24 16:42:09
 * @FilePath: \mapa-web\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/AllNotice',
      name: 'AllNotice',
      component: resolve => require(['@/components/AllNotice/index'], resolve),
      meta: { title: '全部公告' }
    },
    {
      path: '/',
      redirect: "/index"
    },
    {
      path: '/bkHome',
      name: 'bkHome', redirect: "/home",
      component: resolve => require(['@/components/bkHome/index'], resolve),
      meta: { title: '报考', isShow: true },
      children: [
        {
          path: "/home",
          name: "home",
          component: resolve => require(['@/components/bkHome/child/home.vue'], resolve),
          meta: { title: '首页', isShow: true },
        },
        {
          path: "/ksbm",
          name: "ksbm",
          component: resolve => require(['@/components/bkHome/child/ksbm.vue'], resolve),
          meta: { title: '考试报名', isShow: true },
        },
        {
          path: "/shzt",
          name: "shzt",
          component: resolve => require(['@/components/bkHome/child/shzt.vue'], resolve),
          meta: { title: '审核状态', isShow: true },
        },
        {
          path: "/mnlx",
          name: "mnlx",
          component: resolve => require(['@/components/bkHome/child/mnlx.vue'], resolve),
          meta: {
            title: '模拟练习', isShow: true
          },
        },
        {
          path: "/zkzdy",
          name: "zkzdy",
          component: resolve => require(['@/components/bkHome/child/zkzdy.vue'], resolve),
          meta: {
            title: '准考证打印', isShow: true
          },
        },
        {
          path: "/nlsc",
          name: "nlsc",
          component: resolve => require(['@/components/bkHome/child/nlsc.vue'], resolve),
          meta: {
            title: '案例上传', isShow: true
          },
        },
        {
          path: "/cjcx",
          name: "cjcx",
          component: resolve => require(['@/components/bkHome/child/cjcx.vue'], resolve),
          meta: {
            title: '成绩查询', isShow: true
          },
        },
        {
          path: "/user",
          name: "user",
          component: resolve => require(['@/components/bkHome/child/user.vue'], resolve),
          meta: {
            title: '账号安全', isShow: true
          },
        },
      ]
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/components/home/index'], resolve),
      meta: { title: '首页' }
    },
    {
      path: '/curriculum',
      name: 'curriculum',
      component: resolve => require(['@/components/curriculum/index'], resolve),
      meta: { title: '知识体系' }
    },
    {
      path: '/newdetail',
      name: 'newdetail',
      component: resolve => require(['@/components/newdetail/index'], resolve),
      meta: { title: '新闻详情' }
    },
    {
      path: '/signup',
      name: 'signup',
      component: resolve => require(['@/components/signup/index'], resolve),
      meta: { title: '报名入口' }
    },
    {
      path: '/contact',
      name: 'contact',
      component: resolve => require(['@/components/contact/index'], resolve),
      meta: { title: '联系我们' }
    },
    {
      path: '/certificate',
      name: 'certificate',
      component: resolve => require(['@/components/certificate/index'], resolve),
      meta: { title: '证书介绍' }
    },
    {
      path: '/onLine',
      name: 'onLine',
      component: resolve => require(['@/components/onLine/index'], resolve),
      meta: { title: '在线系统' }
    },
    {
      path: '/mechanism',
      name: 'mechanism',
      component: resolve => require(['@/components/mechanism/index'], resolve),
      meta: { title: '机构介绍' }
    },
    {
      path: '/authInst',
      name: 'authInst',
      component: resolve => require(['@/components/signup/jump'], resolve),
      meta: { title: '授权机构' }
    },

    {
      path: '/result',
      name: 'result',
      component: resolve => require(['@/components/review/result'], resolve),
      meta: { title: '特级管理会计师评审进度查询', isShow: true }
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login/Index'], resolve),
      meta: { title: '登录', isShow: true }
    },
    {
      path: '/forgetpwd',
      name: 'forgetpwd',
      component: resolve => require(['@/views/forgetpwd/Index'], resolve),
      meta: { title: '密码设置', isShow: true }
    },
    {
      path: "/alogin",
      name: "adminLogin",
      component: resolve => require(['@/views/alogin/index'], resolve),
      meta: {
        title: '机构端登录', isShow: true
      },
    },
    {
      path: "/blogin",
      name: "xxLogin",
      component: resolve => require(['@/views/blogin/index'], resolve),
      meta: {
        title: '学习登录', isShow: true
      },
    },
    {
      path: "/study",
      name: "study",
      component: resolve => require(['@/views/study/index'], resolve),
      meta: {
        title: '学习首页', isShow: true
      },


    },
    {
      path: "/LearningDetails/:projectId/:courseId/:name/",
      name: "LearningDetails",
      component: resolve => require(['@/views/LearningDetails/index'], resolve),
      meta: {
        title: '学习详情', isShow: true
      },


    },
    {
      path: "/ahome",
      name: "aHome",
      redirect: "/applyInfo",
      component: resolve => require(['@/views/institution/index'], resolve),
      meta: {
        title: '机构端登录', isShow: true
      },
      children: [
        {
          path: "/applyInfo",
          name: "applyInfo",
          component: resolve => require(['@/views/institution/child/index.vue'], resolve),
          meta: { title: '报名信息', isShow: true },
        },
        {
          path: "/companyInfo",
          name: "companyInfo",
          component: resolve => require(['@/views/institution/child/companyInfo.vue'], resolve),
          meta: { title: '机构信息', isShow: true },
        },
        {
          path: "/accountSafe",
          name: "accountSafe",
          component: resolve => require(['@/views/institution/child/accountSafe.vue'], resolve),
          meta: { title: '账号安全', isShow: true },
        },
      ]
    },
    {
      path: "/clogin",
      name: "continueLogin",
      component: resolve => require(['@/views/clogin/index'], resolve),
      meta: {
        title: '继续教育登录', isShow: true
      },
    },
    {
      path: "/chome",
      name: "continueHome",
      redirect: "/chome",
      component: resolve => require(['@/views/continueStudy/index'], resolve),
      meta: {
        title: '继续教育首页', isShow: true
      },
      children: [
        {
          path: "/chome",
          name: "contineHome",
          component: resolve => require(['@/views/continueStudy/child/index.vue'], resolve),
          meta: { title: '继续教育首页', isShow: true },
        },
        {
          path: "/userInfo",
          name: "userInfo",
          component: resolve => require(['@/views/continueStudy/child/userInfo.vue'], resolve),
          meta: { title: '我的信息', isShow: true },
        },
        {
          path: "/regAndPay",
          name: "regAndPay",
          component: resolve => require(['@/views/continueStudy/child/regAndPay.vue'], resolve),
          meta: { title: '报名缴费', isShow: true },
        },
        {
          path: "/classStudy",
          name: "classStudy",
          component: resolve => require(['@/views/continueStudy/child/classStudy.vue'], resolve),
          meta: { title: '课程学习', isShow: true },
        },
        {
          path: "/classDetail",
          name: "classDetail",
          component: resolve => require(['@/views/continueStudy/child/classDetail.vue'], resolve),
          meta: { title: '课程观看', isShow: true },
        },
        {
          path: "/orderManager",
          name: "orderManager",
          component: resolve => require(['@/views/continueStudy/child/orderManager.vue'], resolve),
          meta: { title: '订单管理', isShow: true },
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js